<template>
  <div class="form-login-form">
    <form novalidate class="md-layout" @submit.prevent="validateUser">
      <md-card class="no-shadow md-layout-item md-size-100">
        <md-card-header>
          <div class="md-title">Login</div>
          <div v-if="isNewUser">
            <br>
            <highlight-block-warning>
              We have sent you an email. Please verify it before signing in.
            </highlight-block-warning>
          </div>
        </md-card-header>

        <md-card-content>
          <md-field :class="getValidationClass('email')">
            <label for="email">Email</label>
            <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.email" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.email.required">The email is required</span>
            <span class="md-error" v-else-if="!$v.form.email.email">Invalid email</span>
          </md-field>

          <md-field :class="getValidationClass('password')">
            <label for="password">Password</label>
            <md-input type="password" name="password" id="password" autocomplete="off" v-model="form.password" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.password.required">The password is required</span>
            <span class="md-error" v-else-if="!$v.form.password.password">Invalid password</span>
          </md-field>

          <error-container :error="error">
            <span v-if="isEmailNotVerifiedError">
              Click
              <a href="#" @click="requestNewVerificationMail">here</a>
              to send another email.
            </span>
          </error-container>

        </md-card-content>

        <md-card-actions md-alignment="space-between">
          <md-button type="button" class="md-primary">
            <router-link to="/signup">Create Account</router-link>
          </md-button>
          <md-button type="submit" class="md-raised md-primary" :disabled="sending">
            <span v-show="!sending">
              Login
            </span>
            <span v-show="sending">
              <md-progress-spinner
                :md-diameter="22"
                :md-stroke="2"
                md-mode="indeterminate"
              />
            </span>
          </md-button>
        </md-card-actions>
      </md-card>

      <div class="forgot-password-container">
        <span>Forgot you password?</span>
        <a href="#" @click="requestPasswordLink">Reset Password</a>
      </div>

      <md-snackbar :md-active.sync="userSaved">The user {{ lastUser }} was saved with success!</md-snackbar>
      <md-snackbar :md-active.sync="emailRequested">Check your email. We successfully sent you one :-) </md-snackbar>
    </form>
  </div>
</template>

<script>
import ErrorContainer from '../ErrorContainer'
import HighlightBlockWarning from '../HighlightBlockWarning'
import ErrorFactory from '../../models/ErrorFactory'

import { validationMixin } from 'vuelidate'
import {
  required
} from 'vuelidate/lib/validators'
export default {
  name: 'LoginForm',
  mixins: [validationMixin],
  components: {
    ErrorContainer,
    HighlightBlockWarning
  },
  data: () => ({
    errorFactory: new ErrorFactory(),
    form: {
      email: null,
      password: null
    },
    userSaved: false,
    emailRequested: false,
    sending: false,
    lastUser: null,
    error: null
  }),
  validations: {
    form: {
      email: {
        required
      },
      password: {
        required
      }
    }
  },
  computed: {
    isNewUser () {
      return this.$route.query.new === 'true'
    },
    isEmailNotVerifiedError () {
      return this.error &&
              this.error.errors &&
              this.error.errors[0] &&
              this.error.errors[0].message === 'Please verify your email address.'
    },
    axios () {
      return this.$store.getters['axios']
    },
    base_url () {
      return this.$store.getters['base_url']
    }
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearForm () {
      this.$v.$reset()
      this.form.email = null
      this.form.password = null
    },
    async loginUser () {
      this.sending = true
      try {
        await this.$store.dispatch('login', {
          email: this.form.email,
          password: this.form.password
        })
        await this.$store.dispatch('currentUser')
        let path = this.$route.query.redirect || '/'
        this.$router.push(path)
      } catch (error) {
        this.error = error
      } finally {
        this.sending = false
      }
    },
    async requestNewVerificationMail () {
      this.sending = true
      try {
        await this.axios.post(this.base_url + '/validation/' + this.form.email)

        this.emailRequested = true
        this.error = null
      } catch (error) {
        this.error = this.errorFactory.make(error.response.data, 'Could not request new Verfication Email.')
      } finally {
        this.sending = false
      }
    },
    async requestPasswordLink () {
      this.sending = true
      try {
        await this.axios.post(this.base_url + '/users/reset/' + this.form.email)

        this.emailRequested = true
        this.error = null
      } catch (error) {
        this.error = this.errorFactory.make(error.response.data, 'Could not request new Verfication Email.')
      } finally {
        this.sending = false
      }
    },
    validateUser () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loginUser()
      }
    }
  }
}
</script>

<style lang="scss">
.form-login-form {
  .md-progress-bar {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
  }
  .no-shadow  {
    box-shadow: none;
  }
  .md-title {
    text-align: left;
  }
  .md-error {
    color: red;
  }
  circle.md-progress-spinner-circle {
    stroke: rgba(0, 0, 0, 0.26) !important;
  }
  .forgot-password-container {
    margin-top: 16px;
    margin-left: 16px;
    color: rgba(0,0,0,0.5);
    width: 100%;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forms/LoginForm.vue